import api from './api';

export interface StaffPickDress {
  id: string;
  name: string;
  imageUrl?: string;
  thumbnailUrl?: string;
  designer?: {
    id: string;
    name: string;
  };
}

export interface StaffPick {
  id: string;
  customerId: string;
  dressId: string;
  staffId: string;
  displayOrder: number;
  note?: string;
  createdAt: string;
  updatedAt: string;
  dress: StaffPickDress;
  addedBy: {
    id: string;
    name: string;
  };
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface AddStaffPickRequest {
  dressId: string;
  note?: string;
}

class StaffPicksService {
  async getCustomerPicks(customerId: string, page = 1, limit = 50): Promise<PaginatedResponse<StaffPick>> {
    const response = await api.get(`/staff-picks/customer/${customerId}`, {
      params: { page, limit }
    });
    return response.data;
  }

  async addPick(customerId: string, data: AddStaffPickRequest): Promise<StaffPick> {
    const response = await api.post(`/staff-picks/customer/${customerId}`, data);
    return response.data.data;
  }

  async removePick(customerId: string, dressId: string): Promise<void> {
    await api.delete(`/staff-picks/customer/${customerId}/${dressId}`);
  }

  async updateNote(pickId: string, note: string): Promise<void> {
    await api.put(`/staff-picks/${pickId}/note`, { note });
  }

  async reorderPicks(customerId: string, orderedPickIds: string[]): Promise<void> {
    await api.put(`/staff-picks/customer/${customerId}/reorder`, { orderedPickIds });
  }

  async getPicksCount(customerId: string): Promise<number> {
    const response = await api.get(`/staff-picks/customer/${customerId}/count`);
    return response.data.data.count;
  }
}

export const staffPicksService = new StaffPicksService();
export default staffPicksService;
